// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__toYIQ","text":"SelectPayment_text__1GvCy","title":"SelectPayment_title__3IDTq","btn":"SelectPayment_btn__TiAOA"};